import { useMemo } from "react";
import { skipToken } from "@reduxjs/toolkit/query";

import { useGetCertificationQuery } from "@/redux/service";
import { WELL_BEING_SLUG } from "@/domains/certifications/routes";
import { getWeekByTopic } from "@/domains/certifications/utils";

export const useCertificationWeekByTopic = (enabled = true) => {
  const { data } = useGetCertificationQuery(
    enabled ? WELL_BEING_SLUG : skipToken,
  );
  return useMemo(() => getWeekByTopic(data?.modules ?? []), [data?.modules]);
};
